<template>
<v-card class="panel" elevation="1">
    <div class="subscriptions">
        <v-row v-if="$vuetify.breakpoint.sm">
            <v-col cols="10" md="10" sm="8" xs="6">
                <h2 class="page-title">{{ $page.props.lang.page_title || "Your Measurements" }} </h2>  
            </v-col>
                <v-col cols="2" md="2" sm="4" xs="6">
                    <v-select
                        v-if="measurements != 0"
                        v-model="selectedChart"
                        :items="items"
                        item-text="text"
                        item-value="value"
                        @change="chartSelect"
                        persistent-hint
                        return-object
                        dense
                        outlined
                        flat
                    ></v-select>
                </v-col>
        </v-row>
        <v-row v-else>
            <v-col cols="12" md="10" sm="8" xs="12">
                <h2 class="page-title">{{ $page.props.lang.page_title || "Your Measurements" }} </h2>  
            </v-col>
                <v-col cols="12" md="2" sm="6" xs="4">
                    <v-select
                        v-if="measurements != 0"
                        v-model="selectedChart"
                        :items="items"
                        item-text="text"
                        item-value="value"
                        @change="chartSelect"
                        persistent-hint
                        return-object
                        dense
                        outlined
                        flat
                    ></v-select>
                </v-col>
        </v-row>
        <v-card-text>
            <vue-frappe v-if="measurements != 0"
                id="test"
                :labels="chartLabelsSet"
                :height="300"
                :line-options="{dotSize: 6, regionFill: 1}"
                :tooltip-options="tooltipOption"
                :colors="['#8b1f62']"
                :dataSets="currentDataSet">
            </vue-frappe>
            <v-card v-else class="mx-auto my-12" max-width="350" outlined>
                <v-card-text v-html="$page.props.lang.no_measurement_label || 'You do not have any measurements yet.'" class="text-center "></v-card-text>
            </v-card>
        </v-card-text>
        <v-simple-table
            v-if="measurements != 0"
            mobile-breakpoint="0"
            hide-default-footer
        >
            <template v-slot:default>
                <thead>
                    <tr>
                    <th class="text-left" v-for="header in measurementsHeaders" :key="header.text">{{ header.text }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in measurementsData" :key="item.id">
                        <td>{{ item.date}}</td>
                        <td>{{ item.height }}</td>
                        <td>{{ item.weight }}</td>
                        <td>{{ item.bmi }}</td>
                        <td>{{ item.body_fat }}</td>
                        <td>{{ item.muscular_mass }}</td>
                        <td>{{ item.bone_mass }}</td>
                        <td>{{ item.body_water }}</td>
                        <td v-for="custom in item.customs" :key="custom.id">                     
                                {{ custom.value }}      
                        </td> 
                    </tr>
                </tbody>
            </template>    
        </v-simple-table>
    </div>
</v-card>
</template>


<script>
import PortalLayout from '@/js/Layouts/PortalLayout'
export default{
    metaInfo(){
        return{
             title: (this.$page.props.lang.measurement || "Measurement")
        }
    },
    components: {
    },
    layout: PortalLayout,
    props: {
       measurements: Array,
       customs: Array,
       member: Object
        
    },
    data(){
      return {
        measurementsData: this.measurements,
        startDatePicker: false,
        editStartDatePicker: false,
        responseErrors: {},
        today : new Date().toISOString().substr(0, 10),
        measurementsHeaders: [
                {text: this.$page.props.lang.date || 'Date', value: 'date', align: 'start'},
                {text: this.$page.props.lang.height || 'Height(cm)', value: 'height', sortable: false, align:'start'},
                {text: this.$page.props.lang.weight || 'Weight(kg)', value: 'weight', sortable: false, align: 'left'},
                {text: this.$page.props.lang.bmi || 'BMI', value: 'bmi', sortable: false, align: 'center'},
                {text: this.$page.props.lang.body_fat || 'Body Fat(%)', value: 'body_fat', sortable: false, align: 'center'},
                {text: this.$page.props.lang.muscular_mass || 'Muscular mass(%)', value: 'muscular_mass', sortable: false, align: 'center'},
                {text: this.$page.props.lang.bone_mass || 'Bone Mass(%)', value: 'bone_mass', sortable: false, align: 'center'},
                {text: this.$page.props.lang.body_water || 'Body Water(%)', value: 'body_water', sortable: false, align: 'center'},
            ],
            renderChart: false,
            tooltipOption: {
                label: '',
                valuesOverPoints: 1,
                formatTooltipX: () => '',
                formatTooltipY: (d) => (d + '').toUpperCase()
            },
            chartMonth: '',
            tablePage: 1,
            tablePageCount: 0,
            itemsPerPage: 8,
            sortBy:'date',
            sortDesc:true,
            toggle_exclusive: 0,
            items: [
            { text: this.$page.props.lang.weight || 'Weight(kg)', value: 0},
            { text: this.$page.props.lang.height || 'Height(cm)', value: 1},
            { text: this.$page.props.lang.bmi || 'BMI', value: 2},
            { text: this.$page.props.lang.body_fat || 'Body fat(%)', value: 3},
            { text: this.$page.props.lang.muscular_mass || 'Muscle mass(%)', value: 4},
            { text: this.$page.props.lang.bone_mass || 'Bone mass(%)', value: 5 },
            { text: this.$page.props.lang.body_water || 'Body water(%)',value: 6 }
            ],
            currentDataSet: [],
            selectedChart: {text: this.$page.props.lang.weight || 'Weight(kg)', value: 0},
            chartLabelsSet:[],
            chartDataSet:{}
      }
    },
    mounted(){
        this.renderChart = true
    },

    created(){

        var data = this.measurementsData.map(item => {
                return item.weight
                });
                this.currentDataSet = [{
                    name: this.$page.props.lang.weight || 'Weight(kg)', chartType: 'line',
                    values: data
                }];
                this.chartLabelsSet = this.measurementsData.map(item => {
                    return moment(item.data).format('DD.MM.YYYY')
                })

        this.setUpTableHeaders();
        this.addCustomsToChart();
    },

    methods:{

        setUpTableHeaders(){
          
            this.customs.forEach(item => {
                let customObjHeaders = {};

                customObjHeaders.text = item.label+'('+item.type+')';
                customObjHeaders.value = item.order_number.toString();
                customObjHeaders.align = 'center';
                customObjHeaders.sortable = 'false';

                return this.measurementsHeaders.push(customObjHeaders);
            });
        },

        addCustomsToChart(){
            
            this.customs.forEach(element => {

                const chartCount = this.items.length;
                const lastItem = this.items[chartCount - 1]['value'];
                let customMeasurementObj = {};
                customMeasurementObj.text = element.label+'('+element.type+')';
                customMeasurementObj.value = 'cust-'+element.id;

                return this.items.push(customMeasurementObj);
                
            });            

        },

        chartSelect(){
            axios.get('/portal/measurement/getChartData/'+ this.selectedChart.value +'/'+ this.member.id)
                .then(response => {
                    if(response.data.status === "OK"){
                        this.chartLabelsSet = response.data.labels;
                        this.chartDataSet = response.data.chartData;
                        this.chartDataSet.name = this.selectedChart.text;
                        this.chartDataSet.chartType = 'line',
                        this.currentDataSet.splice(0, 1, this.chartDataSet);
                    }else{
                        EventBus.$emit('SHOW_NOTIFICATION',{ 
                                message: response.data.message,
                                color: 'error',
                                timeout: 5000
                            })
                    }
                });
        },

       
    }
 
}

</script>